interface Params {
  [key: string]: string;
}

function toObject(params: URLSearchParams): Params {
  const out: Params = {};
  params.forEach((value, key) => {
    out[key] = value;
  });
  return out;
}

export function addParametersToQueryString(str: string, params: Params) {
  const merged = { ...toObject(new URLSearchParams(str)), ...params };
  return new URLSearchParams(merged).toString();
}

export function removeParameterFromQueryString(str: string, key: string) {
  const sp = new URLSearchParams(str);
  sp.delete(key);
  return sp.toString();
}

export function removeHashesFromQueryString(
  str: string,
  ...hashKeys: string[]
) {
  const sp = new URLSearchParams(str);
  const toDelete: string[] = [];
  sp.forEach((_value, key) => {
    if (hashKeys.includes(key.split("[")[0])) toDelete.push(key);
  });
  toDelete.forEach((k) => sp.delete(k));
  return sp.toString();
}
